import React from 'react';
import { ReportProblemOutlined } from '@material-ui/icons';

export const IsVoiceNoLicenseWarn = () => {
  return (
    <div className="m-user-edit-drawer-section__no-licenses-warn">
      <div className="m-user-edit-drawer-section__no-licenses-warn__icon">
        <ReportProblemOutlined />
      </div>
      <div>
        <span className="m-user-edit-drawer-section__no-licenses-warn__bold">
          Warning!{' '}
        </span>
        Once saved, this user will not be licensed for voice products, and all
        voice data will be lost.
      </div>
    </div>
  );
};
